import { render } from "./synthesisTab.vue?vue&type=template&id=939ec08a"
import script from "./synthesisTab.vue?vue&type=script&lang=ts"
export * from "./synthesisTab.vue?vue&type=script&lang=ts"

import "./synthesisTab.vue?vue&type=style&index=0&id=939ec08a&lang=scss"
script.render = render

export default script